export default __webpack_public_path__ + "static/media/hotelconfigure.e213e41f.svg";